import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  // ✅ Don't set Content-Type here - let axios handle it automatically
});

// Request interceptor - Add token and handle Content-Type dynamically
api.interceptors.request.use(
  (config) => {
    // Get token from localStorage
    const token = localStorage.getItem("token");
    
    // If token exists, add it to headers
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // ✅ Only set Content-Type to JSON if it's NOT FormData
    // FormData needs its own Content-Type with boundary
    if (!(config.data instanceof FormData)) {
      config.headers["Content-Type"] = "application/json";
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - Handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const currentPath = window.location.pathname;
    const requestUrl = error.config?.url || "";
    if (
      status === 401 &&
      // requestUrl.includes("/api/adminuser/login")
      ''
    ) {
      return Promise.reject(error);
    }

    if (status === 401) {
      // 🔐 ADMIN ROUTES
      if (currentPath.startsWith("/admin")) {
        localStorage.removeItem("token");
        // window.location.href = "/admin/login";
      }
      // 👤 USER ROUTES
      else {
        localStorage.removeItem("token");
        // window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export default api;